import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import classNames from "classnames";

import feather from "feather-icons";

const Icon = ({
  classes,
  iconName,
  color = "#000",
  size = 24,
  text,
  ...rest
}) => {
  const icon = feather.icons[iconName];
  if (!icon) {
    throw new Error("Icon with name '" + iconName + "' does not exists.");
  }
  return (
    <span
      className={classNames({
        [classes.root]: true,
        [rest.className]: rest.className
      })}
    >
      <span
        className={classes.icon}
        dangerouslySetInnerHTML={{
          __html: icon.toSvg({
            color: color === "function",
            width: size,
            height: size
          })
        }}
      />
      {text && <span className={classes.text}>{text}</span>}
    </span>
  );
};

Icon.propTypes = {
  classes: PropTypes.object.isRequired,
  iconName: PropTypes.string.isRequired,
  color: PropTypes.string,
  size: PropTypes.number,
  text: PropTypes.string
};

const styles = () => ({
  root: {
    display: "inline-block"
  },
  icon: {
    "& > svg": {
      display: "inline-block",
      verticalAlign: "middle"
    }
  },
  text: {
    marginLeft: 5
  }
});

export default injectSheet(styles)(Icon);



// WEBPACK FOOTER //
// ./src/components/shared/Icon.js